import Vue from 'vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-sugar.css';

const opts = {
    duration: 5000,
    dismissible: true
}

export default Vue.use(VueToast, opts);